import * as iter from './utils/iter';

/**
 * @param {boolean} condition
 * @param {string} [msg]
 * @returns {void}
 */
export function assert(condition, msg = 'Assertion error') {
	if (!condition) {
		throw new Error(msg);
	}
}

// eslint-disable-next-line jsdoc/require-returns-check
/**
 * @param {string} msg
 * @throws
 * @returns {never} ...
 */
export function unreachable(msg = 'Unreachable reached') {
	throw new Error(msg);
}

/**
 * @param {Object<string, string>} classes
 * @param {string} name Name of block or element
 * @param {Object<string, boolean>|Array<string|false|null|undefined>|string|false|null|undefined} mods
 * @returns {string} ...
 */
export function styleMods(classes, name, mods) {
	if (typeof mods === 'string') {
		mods = [mods];
	}

	if (mods !== null && typeof mods === 'object' && !Array.isArray(mods)) {
		mods = Object.entries(mods)
			.filter(([_, val]) => val === true)
			.map(([key, _]) => key);
	}

	if (!Array.isArray(mods)) {
		mods = [];
	}

	return [
		name,
		...mods
			.filter((m) => m !== false && m !== null && m !== undefined)
			.map((m) => `${name}_${m}`),
	]
		.map((c) => classes[c])
		.filter((c) => typeof c === 'string')
		.join(' ');
}

/**
 * @template T
 * @template G
 * @param {Iterable<T>} it
 * @param {(t: T) => G} f
 * @returns {IterableIterator<[G, Array<T>]>} ...
 */
export function groupByKey(it, f) {
	/** @type {Map<G, Array<T>>} */
	const map = new Map();
	for (const v of it) {
		const key = f(v);
		const group = map.get(key);
		if (group !== undefined) {
			group.push(v);
		} else {
			map.set(key, [v]);
		}
	}
	return iter.from(map.entries());
}

/**
 * @param {string} name
 * @param {[number, number]} coordinates
 */
export function createNavigationUrlApple(name, coordinates) {
	return `https://maps.apple.com/?daddr=${coordinates[1]},${coordinates[0]}&dirflg=w&ll=${coordinates[1]},${coordinates[0]}&q=${encodeURIComponent(name)}`;
}

/**
 * @param {string} name
 * @param {[number, number]} coordinates
 */
export function createNavigationUrlGoogle(name, coordinates) {
	return `https://www.google.com/maps/dir/?api=1&destination=${coordinates[1]},${coordinates[0]}`;
}
